import React from 'react';
import styled from 'styled-components';
import { device } from '../../../../../../utils/use-device-type';

const BlogPostSkeleton: React.FC = () => {
  return (
    <PostContainer>
      <Box>
        <Media />
      </Box>
      <BoxText>
        <TitleLine />
        <LinkLine />
      </BoxText>
    </PostContainer>
  );
};

export default BlogPostSkeleton;

const shimmer = `
  background: linear-gradient(90deg, #eef1f6 25%, #e3e7ef 37%, #eef1f6 63%);
  background-size: 400% 100%;
  animation: shimmer 1.2s infinite;
  @keyframes shimmer {
    0% { background-position: 100% 0; }
    100% { background-position: 0 0; }
  }
`;

const PostContainer = styled.div`
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  width: 100%;
  max-width: 253px;
  border-radius: 15px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  @media (min-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 290px;
    height: 254px;
  }
  @media (min-width: 1024px) {
    max-width: 353px;
    height: 320px;
  }
`;

const Box = styled.div`
  width: 100%;
  padding: 13px 10px 0 10px;
  @media ${device.splitScreen} {
    height: 180px;
    width: 340px;
    padding: 23px 20px 0 20px;
  }
  @media ${device.laptop} {
    width: 100%;
    height: auto;
  }
`;

const Media = styled.div`
  height: 135px;
  width: 224px;
  border-radius: 15px;
  ${shimmer}
  @media ${device.splitScreen} {
    height: 156px;
    width: 258px;
  }
  @media ${device.laptop} {
    height: 189px;
    width: 319px;
  }
`;

const BoxText = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  justify-content: space-between;
  @media ${device.laptop} {
    height: 100%;
    flex-direction: column;
    padding: 20px 20px 0 20px;
    justify-content: space-between;
  }
`;

const TitleLine = styled.div`
  height: 24px;
  width: 70%;
  border-radius: 6px;
  ${shimmer}
`;

const LinkLine = styled.div`
  height: 18px;
  width: 120px;
  border-radius: 6px;
  margin: 10px 0;
  ${shimmer}
`;
